export default __webpack_public_path__ + "static/media/house_match_photo.a2ea74de.svg";